import { v4 as uuidv4 } from 'uuid'

export const successionTestData = {
  title: 'Succession',
  item: '2 Potential Gen 2 Advisors on the team',
  key: uuidv4()
}
